import { OrderTypeDesc } from "TradeAPILib";
export function groupBotOrderList(orderList, currentTradePair) {
  var result = createEmptyBotOrderCollection();
  orderList.forEach(function (orderItem) {
    if (orderItem.orderType === OrderTypeDesc.GRID) {
      result.grid = processExchangeOrderToBotOrderCollection(orderItem, result.grid, currentTradePair);
    } else if (orderItem.orderType === OrderTypeDesc.STOP_LIMIT) {
      result.stopLimit = processExchangeOrderToBotOrderCollection(orderItem, result.stopLimit, currentTradePair);
    } else if (orderItem.orderType === OrderTypeDesc.TRAILING_STOP_LIMIT) {
      result.trailingStopLimit = processExchangeOrderToBotOrderCollection(orderItem, result.trailingStopLimit, currentTradePair);
    }
  });
  return result;
}
function processExchangeOrderToBotOrderCategoriesItem(orderItem, result, currentTradePair) {
  result.all.push(orderItem);
  if (orderItem.base.toUpperCase() === currentTradePair.base.toUpperCase() && orderItem.quote.toUpperCase() === currentTradePair.quote.toUpperCase()) {
    result.current.push(orderItem);
  } else {
    result.others.push(orderItem);
  }
  return result;
}
function processExchangeOrderToBotOrderCollection(orderItem, result, currentTradePair) {
  if (orderItem.state === "submitted") {
    result.running = processExchangeOrderToBotOrderCategoriesItem(orderItem, result.running, currentTradePair);
  } else if (orderItem.state === "canceling") {
    result.canceling = processExchangeOrderToBotOrderCategoriesItem(orderItem, result.canceling, currentTradePair);
  } else if (orderItem.state === "filled") {
    var profit_taken = 0;
    if (orderItem.exchangeTrailingStopLimitOrder) {
      profit_taken = orderItem.exchangeTrailingStopLimitOrder.profit_taken;
    }
    if (orderItem.orderType === OrderTypeDesc.TRAILING_STOP_LIMIT && profit_taken === 0) {
      //已完成，未确认收益
      result.running = processExchangeOrderToBotOrderCategoriesItem(orderItem, result.running, currentTradePair);
    } else {
      result.history = processExchangeOrderToBotOrderCategoriesItem(orderItem, result.history, currentTradePair);
    }
  } else if (orderItem.state === "canceled") {
    ///> 判断是可恢复的网格订单
    var canRetry = false;
    if (orderItem.exchangeGridOrder) {
      canRetry = orderItem.exchangeGridOrder.canRetry;
    }
    if (orderItem.orderType === OrderTypeDesc.GRID && canRetry) {
      result.retry = processExchangeOrderToBotOrderCategoriesItem(orderItem, result.retry, currentTradePair);
    } else {
      result.canceled = processExchangeOrderToBotOrderCategoriesItem(orderItem, result.canceled, currentTradePair);
    }
  }
  return result;
}
function createEmptyBotOrderCategrayItem() {
  return {
    all: [],
    current: [],
    others: []
  };
}
function createEmptyBotOrderCategory() {
  return {
    running: createEmptyBotOrderCategrayItem(),
    canceling: createEmptyBotOrderCategrayItem(),
    canceled: createEmptyBotOrderCategrayItem(),
    history: createEmptyBotOrderCategrayItem(),
    retry: createEmptyBotOrderCategrayItem()
  };
}
function createEmptyBotOrderCollection() {
  var collection = {
    grid: createEmptyBotOrderCategory(),
    stopLimit: createEmptyBotOrderCategory(),
    trailingStopLimit: createEmptyBotOrderCategory()
  };
  return collection;
}